import React, { useRef, useState } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import './timepicker-custom-styles.css'

import InputMask from 'react-input-mask'
import TimePickerCustom from './TimePickerCustom'

// const InputMask = ({...props}) =>{
//   return <div />
// }

const TimePickerInput = ({
  value,
  onChange,
  readOnly,
  name,
  placeholder = '00:00',
  iconClass = 'fas fa-caret-down',
  placement = 'bottom',
  flip = true,
  clearable = false,
  clearIconClass = '',
  toggleLabel = 'เลือกเวลา',
  popoverClassName = '',
  ...props
}) => {
  const [timeValue, setTimeValue] = useState('')
  const [showPicker, setShowPicker] = useState(false)
  const inputNameRef = useRef(
    `time-picker-${name || 'input'}-${Math.random().toString(36).slice(2)}`,
  )

  const handleChangeTime = (newValue) => {
    setTimeValue(newValue)
    if (onChange) {
      onChange(newValue)
    }
  }

  const handleTogglePicker = (e) => {
    e?.preventDefault()
    e?.stopPropagation()
    setShowPicker(!showPicker)
  }

  const handlePickerToggle = (nextShow) => {
    setShowPicker(nextShow)
  }

  const timePicker = (time) => {
    return (
      <Popover
        id={inputNameRef.current + '-popover'}
        className={'popover-timepicker ' + popoverClassName}
      >
        <Popover.Content>
          <TimePickerCustom
            value={time}
            onChange={(value) => handleChangeTime(value)}
            // onClose={handleTogglePicker}
            onClose={() => setShowPicker(false)}
          />
        </Popover.Content>
      </Popover>
    )
  }

  return (
    <div className="position-relative">
      <InputMask
        {...props}
        name={inputNameRef.current}
        data-field-name={name}
        value={value ?? timeValue}
        className={`form-control${clearable ? ' pr-time' : ''}`}
        placeholder={placeholder}
        mask={'99:99'}
        maskChar={null}
        autoComplete="off"
        aria-autocomplete="none"
        inputMode="numeric"
        readOnly={readOnly}
        onClick={handleTogglePicker}
        onChange={(e) => handleChangeTime(e.target.value)}
      />

      {clearable && !readOnly && (value ?? timeValue) && (
        <button
          type="button"
          className="time-clear-btn"
          aria-label="ล้างเวลา"
          onClick={() => {
            handleChangeTime('')
            setShowPicker(false)
          }}
        >
          {clearIconClass ? <i className={clearIconClass} /> : '×'}
        </button>
      )}

      {!readOnly && (
        <OverlayTrigger
          trigger="click"
          placement={placement}
          flip={flip}
          overlay={timePicker(value)}
          rootClose={true}
          show={showPicker} // Controlled by state
          onToggle={handlePickerToggle}
        >
          <button
            type="button"
            className="caret-btn"
            aria-label={toggleLabel}
            aria-expanded={showPicker}
            onClick={handleTogglePicker}
          >
            <i className={iconClass}></i>
          </button>
        </OverlayTrigger>
      )}
    </div>
  )
}

export default TimePickerInput
